import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'postpaid',
  subTitle: '9812345678',
  heading: 'Arun Kataria',
  subHeading: 'Aug 01, 12:15 PM',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam a mi sodales, dapibus elit vel, varius felis. In bibendum dictum elementum.',
  infoIconName: 'TickEnclosedFilledIcon',
  infoText: 'payment for postpaid plan',
  infoTagWidgetIconName: 'InfoIcon',
  infoTagWidget: 'payment for postpaid plan',
  showInfoIcon: true,
  infoIconTooltipText: 'place descriptor here',
  infoTagType: 'default',
  cardMainTitleWidget: true,
  thumbnails: [{
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }, {
    imageUrl: 'https://placehold.co/72',
    imageName: 'image1.png'
  }]
}, getTestId('ReviewWidgetContainer'));